/**
 * PlayerTrackTerms Component
 */

import { getTermsByTaxonomy, TaxonomyType } from '../../../../relay/selectors/taxonomy';
import './styles.scss';

import { flatMap, intersection, isEqual, pullAllBy, shuffle } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityTransitionGroup } from 'velocity-react';

import { QueryStringContext } from '../../../../contexts/queryString';
import { getSearchFilters } from '../../../../contexts/queryString/selectors';
import Button from '../../../atoms/buttons/Button';
import { FindSimilarButton } from '../../../atoms/buttons/FindSimilarButton';
import { IconArrowRight2, IconX } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { PlayerTrackTag } from './PlayerTrackTag';

interface IQueryStringContextProps {
  searchFilters: SearchFilter[];
}

interface IOwnProps {
  open: boolean;
  terms: GQL.ITaxonomyTerm[];
  slug: string;
  track: GQL.ITrackSearchResult;
  onClose?(): void;
}

type PlayerTrackTermsProps = IOwnProps & IQueryStringContextProps;

const classes = new BEM('player__track-terms');

class PlayerTrackTerms extends React.Component<PlayerTrackTermsProps, any> {
  selectedTerms: GQL.ITaxonomyTerm[];

  constructor(props: PlayerTrackTermsProps) {
    super(props);

    this.selectTrackTerms();
  }

  componentWillReceiveProps(nextProps: PlayerTrackTermsProps) {
    if (!isEqual(nextProps.terms, this.props.terms)) {
      this.selectTrackTerms(nextProps.terms);
    }
  }

  render() {
    return (
      <div {...classes()}>
        <div {...classes('wrapper')}>
          <Heading is="h5" {...classes('title')}>This track is:</Heading>
          <VelocityTransitionGroup
            component="ul"
            enter={{
              animation: 'transition.slideUpIn',
              stagger: 25,
              duration: 150,
              display: 'flex',
              delay: 250,
            }}
            {...classes('list')}
          >
          {this.props.open && this.selectedTerms.map(({ id, name }) => (
            <PlayerTrackTag
              key={`${this.props.slug}-${id}`}
              id={id}
              name={name!}
              {...classes('term')}
            />
          ))}
          </VelocityTransitionGroup>
          {/* <LinkButtonWithLicense
            to={TrackPagePath(this.props.slug)}
            external
            label="View All Tags"
            colorScheme="light"
            size="small"
            {...classes('button-view-all') }
          /> */}
          <FindSimilarButton
            actionSource="player_terms_panel"
            track={this.props.track}
            colorScheme="transparent"
            size="small"
            variant="normal"
            label="Find similar tracks"
            icon={<IconArrowRight2 />}
            iconPosition="right"
            {...classes('button-find-similar') }
          />
          <Button
            variant="icon"
            icon={<IconX />}
            size="xsmall"
            onClick={() => this.props.onClose && this.props.onClose()}
            {...classes('button-close') }
          />
        </div>
      </div>
    );
  }

  private selectTrackTerms(terms = this.props.terms) {
    const moods = this.getTermsForType(TaxonomyType.Moods, terms);
    const genres = this.getTermsForType(TaxonomyType.Genres, terms);

    this.selectedTerms = moods.terms.length > 5 ? moods.terms.slice(0, 5) : moods.terms;
    this.selectedTerms = this.selectedTerms.concat(genres.terms.length > 3 ? genres.terms.slice(0, 3) : genres.terms);
    this.selectedTerms = moods.searchedTerms.concat(genres.searchedTerms, shuffle(this.selectedTerms));
  }

  private getTermsForType(type: TaxonomyType, terms: GQL.ITaxonomyTerm[]) {
    const termsForType = getTermsByTaxonomy(type, terms);
    const termsStrings = termsForType.map(({ name }) => name);
    const searchedTermsForType =
      flatMap(intersection(termsStrings, this.props.searchFilters.map(({name}) => name))
      .map((termName) => termsForType.filter(({ name }) => name === termName)));

    pullAllBy(termsForType, searchedTermsForType, 'name');

    return { terms: termsForType, searchedTerms: searchedTermsForType };
  }
}

const PlayerTrackTermsWithQueryStringContext: React.SFC<IOwnProps> = (props) => (
  <QueryStringContext.Consumer>
    {(ctx) => <PlayerTrackTerms searchFilters={getSearchFilters(ctx)} {...props} />}
  </QueryStringContext.Consumer>
);

export default PlayerTrackTermsWithQueryStringContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/Player/PlayerTrackTerms.tsx